<script>
    import {TRANS} from "@/assets/plugins/mps-common/translation/messages";

    export default {
        name: "MessageTranslation",
        data() {
            return {
                TRANS: TRANS, // 번역 키와 번역 메시지를 쌍으로 가지는 상수
            }
        },
    }
</script>